var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLolEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1753_78885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 42.4319C2.85964 42.4132 -6.51666 19.7752 6.65102 6.58267C14.4676 -1.56309 28.5327 -1.5644 36.3492 6.58299C49.5169 19.7767 40.1394 42.4143 21.5001 42.4319ZM21.5001 2.23675C10.9158 2.23675 2.30486 10.8477 2.30486 21.432C3.35929 46.8971 39.6448 46.8896 40.6953 21.4318C40.6953 10.8477 32.0844 2.23675 21.5001 2.23675Z",
    fill: "url(#paint0_linear_1753_78885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 2.23675C10.9158 2.23675 2.30486 10.8477 2.30486 21.432C3.35929 46.8971 39.6448 46.8896 40.6953 21.4318C40.6953 10.8477 32.0844 2.23675 21.5001 2.23675Z",
    fill: "url(#paint1_linear_1753_78885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4312 26.2986H12.7358C12.3154 26.2986 11.9746 26.6449 11.9746 27.072C11.9746 31.7528 16.2851 35.561 21.5835 35.561C26.882 35.561 31.1925 31.7528 31.1925 27.072C31.1924 26.6449 30.8517 26.2986 30.4312 26.2986Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3809 33.6304C17.1436 31.0618 19.1951 29.76 21.4993 29.76C23.8775 29.76 25.9009 31.0235 27.6448 33.6071C23.8871 36.7772 19.1435 36.7857 15.3809 33.6304Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.384 16.4021L29.5798 20.6446L33.7872 16.3901C35.7727 14.1848 32.687 11.1271 30.3687 13.3285C29.9189 13.7418 29.2109 13.7336 28.7714 13.3102C26.6361 11.238 23.316 14.0026 25.384 16.4021Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22967 16.4023L13.4255 20.6448L17.6329 16.3904C19.6184 14.1851 16.5328 11.1273 14.2145 13.3288C13.7647 13.742 13.0567 13.7339 12.6172 13.3104C10.4819 11.2383 7.16174 14.0029 9.22967 16.4023Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1753_78885",
    x1: 3.309,
    y1: 31.9465,
    x2: 39.6732,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1753_78885",
    x1: 3.309,
    y1: 31.9465,
    x2: 39.6732,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1753_78885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5 0.452393)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLolEmoji);
export default __webpack_public_path__ + "static/media/lol-emoji.1b02c030b2aaf8aa4a396a4c6cd694a4.svg";
export { ForwardRef as ReactComponent };